/**
 * Pre-compiled pt-BR messages for SplitButton
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { noActionsAvailable: `Não há ações disponíveis` };
